/* eslint-disable max-lines-per-function */
import {
  Button,
  SheetBody,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@e2n/ui/v2';
import { useRotationsplanById } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplanById/useRotationsplanById';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { CREATE_BEWERTUNG_FORM_ID } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/constants';
import { useForm } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateBewertung/useForm';
import { useRegisterSheetForm } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/SheetWrapper/useRegisterSheetForm';
import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { ArbeitsbereichStationInfo } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateBewertung/components/ArbeitsbereichStationInfo';
import { Rating } from '@/components/FeadbackToggle/Rating';

export function CreateBewertung() {
  const { t } = useTranslation();
  const { id, stationId } = useParams();
  const { rotationsplan } = useRotationsplanById(id ?? '');

  if (!rotationsplan || !stationId || !id) {
    return <Navigate to="/mitarbeiter/rotationsplaene" />;
  }

  const station = rotationsplan.allStationen
    .filter((station) => station instanceof ArbeitsbereichStation)
    .find((station) => station.id === stationId);

  if (!station) {
    return <Navigate to={`/mitarbeiter/rotationsplan/${rotationsplan.id}`} />;
  }

  const ratings = [
    {
      value: 1,
    },
    {
      value: 2,
    },
    {
      value: 3,
    },
    {
      value: 4,
    },
    {
      value: 5,
    },
  ];

  const form = useForm({ stationId, rotationsplanId: id });

  useRegisterSheetForm(form);

  return (
    <div className="flex h-full flex-col bg-backgrounds-secondary">
      <SheetHeader
        actions={
          <Button form={CREATE_BEWERTUNG_FORM_ID}>{t('actions.fertig')}</Button>
        }>
        <SheetTitle className="flex-1">
          {t(
            'domain.mitarbeiter.rotationsplan.rotationsplaene.createBewertung.title',
          )}
        </SheetTitle>
      </SheetHeader>
      <SheetBody className="flex flex-col gap-6 md:px-6 grow overflow-auto">
        <ArbeitsbereichStationInfo station={station} />
        <form
          id={CREATE_BEWERTUNG_FORM_ID}
          className="flex flex-col gap-6 h-full"
          onSubmit={(e) => {
            e.preventDefault();
            form.handleSubmit();
          }}>
          <form.AppField name="sterne">
            {(field) => (
              <FieldBase
                label={t(
                  'domain.mitarbeiter.rotationsplan.rotationsplaene.createBewertung.fields.sterne.label',
                )}>
                <Rating
                  ratings={ratings}
                  defaultValue={field.state.value}
                  onChange={(e) => field.handleChange(e)}
                  allowDeselect
                  starSize={36}
                  filledColor="var(--color-brand-red-200)"
                  emptyColor="var(--color-neutrals-v2-500)"
                />
              </FieldBase>
            )}
          </form.AppField>
          <form.AppField name="beurteilung">
            {(field) => (
              <field.TextAreaInput
                label={t(
                  'domain.mitarbeiter.rotationsplan.rotationsplaene.createBewertung.fields.beurteilung.label',
                )}
                placeholder={t(
                  'domain.mitarbeiter.rotationsplan.rotationsplaene.createBewertung.fields.beurteilung.placeholder',
                )}
                maxLength={400}
                showCounter
              />
            )}
          </form.AppField>
        </form>
      </SheetBody>
      <SheetFooter>
        <Button
          type="submit"
          disabled={!form.state.isValid || form.state.isSubmitting}
          form={CREATE_BEWERTUNG_FORM_ID}>
          {t('actions.fertig')}
        </Button>
      </SheetFooter>
    </div>
  );
}
